import React from 'react';
import { useLocation, Navigate, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';

const ConfirmEmail: React.FC = () => {
  const location = useLocation();
  const email = location.state?.email;
  const name = location.state?.name;

  if (!email) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow bg-gradient-to-br from-[#15213A] via-[#1E3A8A] to-[#15213A] py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md mx-auto">
          <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-xl overflow-hidden border border-white/20">
            <div className="p-8">
              <div className="text-center mb-8">
                <div className="flex justify-center mb-6">
                  <div className="w-16 h-16 bg-[#15213A] rounded-full flex items-center justify-center border-2 border-white/20">
                    <span role="img" aria-label="email" className="text-3xl">✉️</span>
                  </div>
                </div>
                <h2 className="text-2xl font-bold text-[#15213A] mb-2">Check Your Email</h2>
                <p className="text-[#15213A]/70">
                  Hi {name || 'there'}, we've sent a confirmation email to <strong>{email}</strong>
                </p>
              </div>

              <div className="space-y-6">
                <div className="bg-[#15213A] rounded-lg p-6 border border-white/20">
                  <h3 className="font-medium text-white mb-3">Next steps:</h3>
                  <ol className="space-y-3 text-white/80">
                    <li className="flex items-start">
                      <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-white text-[#15213A] text-sm mr-3 font-medium">1</span>
                      <span>Open your email inbox</span>
                    </li>
                    <li className="flex items-start">
                      <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-white text-[#15213A] text-sm mr-3 font-medium">2</span>
                      <span>Look for an email from Kloud Skool</span>
                    </li>
                    <li className="flex items-start">
                      <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-white text-[#15213A] text-sm mr-3 font-medium">3</span>
                      <span>Click the confirmation link</span>
                    </li>
                  </ol>
                </div>

                <div className="bg-[#1E3A8A] rounded-lg p-6 border border-white/20">
                  <p className="font-medium text-white mb-3">Haven't received the email?</p>
                  <ul className="space-y-3 text-white/80">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" />
                      </svg>
                      Check your spam/junk folder
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" />
                      </svg>
                      Email might take a few minutes
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#15213A] border-t border-[#15213A]/10">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            <div className="text-white/60 text-sm">
              © 2025 Kloud Skool. All rights reserved.
            </div>
            <div className="text-white/60 text-sm">
              Need help? Contact us at{' '}
              <a href="mailto:support@kloudskool.com" className="text-white hover:text-white/80">
                support@kloudskool.com
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ConfirmEmail; 